/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Status_Document_PendingInputs */

const en_fulfillment_status_document_pending = /** @type {(inputs: Fulfillment_Status_Document_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document pending`)
};

/**
* | output |
* | --- |
* | "Document pending" |
*
* @param {Fulfillment_Status_Document_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_status_document_pending = /** @type {((inputs?: Fulfillment_Status_Document_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Status_Document_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_status_document_pending(inputs)
});